export default function GoogleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M19.9998 10.2273C19.9998 9.51816 19.9349 8.83636 19.8143 8.18176H10.2041V12.05H15.6956C15.4591 13.3 14.7402 14.3591 13.6595 15.0682V17.5773H16.9572C18.8867 15.8364 19.9998 13.2727 19.9998 10.2273Z"
        fill="#4285F4"
      />
      <path
        d="M10.2036 20C12.9586 20 15.2684 19.1045 16.9566 17.5773L13.6589 15.0682C12.7452 15.6682 11.5764 16.0227 10.2036 16.0227C7.54586 16.0227 5.29641 14.2636 4.49398 11.9H1.08496V14.4909C2.76401 17.7591 6.21476 20 10.2036 20Z"
        fill="#34A853"
      />
      <path
        d="M4.4943 11.9C4.29022 11.3 4.17431 10.6591 4.17431 10C4.17431 9.3409 4.29022 8.7 4.4943 8.1V5.50909H1.08528C0.394278 6.85909 0 8.3864 0 10C0 11.6136 0.394278 13.1409 1.08528 14.4909L4.4943 11.9Z"
        fill="#FBBC04"
      />
      <path
        d="M10.2036 3.9773C11.7016 3.9773 13.0467 4.4818 14.1042 5.4727L17.0309 2.6045C15.2638 0.9909 12.9539 0 10.2036 0C6.21476 0 2.76401 2.2409 1.08496 5.5091L4.49398 8.1C5.29641 5.7364 7.54586 3.9773 10.2036 3.9773Z"
        fill="#E94235"
      />
    </svg>
  );
}
